import Loading from "../components/loading";

export default function VerifyCodeBtn({
  page,
  handleGetCode,
  count,
  otpLoading,
  t,
  config,
}) {
  const handleClick = () => {
    handleGetCode();
  };

  //*** HomePage button ***//
  const GetCodeHome = () => {
    return (
      <>
        <button
          type="button"
          className={`getCodeBtn ${page}`}
          onClick={handleClick}
        >
          {t("forgetPwd_otpBtn_label")}
        </button>

        <style jsx="true">{`
          .getCodeBtn {
            position: absolute;
            bottom: 22px;
            right: 0;

            background-color: ${config.theme.color};
            color: #fff;
            padding: 5px 8px;

            // color: ${config.theme.color};
            // background: transparent;
            font-size: 15px;
            font-weight: bold;
            border: none;
            white-space: nowrap;
          }
        `}</style>
      </>
    );
  };

  const CountDownHome = () => {
    return (
      <>
        <p className={`countDown ${page}`}>
          {t("forgetPwd_resendOtp_label")}
          <span id="countDown">({count}s)</span>
        </p>

        <style jsx="true">{`
          .countDown {
            color: #fff;
            background-color: #d8d8d8;
            border-radius: 5px;
            padding: 3px 7px;
            position: absolute;
            bottom: 10px;
            right: 0;
            font-weight: bold;
          }
        `}</style>
      </>
    );
  };

  const VerifyBtnHome = () => {
    return count !== 0 && !otpLoading ? (
      <CountDownHome />
    ) : count === 0 && otpLoading ? (
      <Loading className="otpLoadingHome" color={"#41413A"} />
    ) : (
      <GetCodeHome />
    );
  };
  //*** End of HomePage button ***//

  //*** RedeemPage button ***//
  const GetCodeRedeem = () => {
    return (
      <>
        <button
          type="button"
          disabled={false}
          className="getCodeBtn"
          onClick={handleClick}
        >
          獲取驗證碼
        </button>

        <style jsx="true">{`
          .getCodeBtn {
            padding: 0px 16px;
            position: unset;
            background-color: ${config.theme.color};
            color: #ffffff;
            border: 2px rgb(118, 118, 118) outset;
            font-size: 14px;
          }
          @media (min-width: 641px) {
            .getCodeBtn {
              padding: 0px 25px !important;
              width: 165px !important;
            }
          }
        `}</style>
      </>
    );
  };

  const CountDownRedeem = () => {
    return (
      <>
        <button type="button" disabled={true} className="getCodeBtn">
          重發驗證碼({count}s)
        </button>

        <style jsx="true">{`
          .getCodeBtn:disabled {
            font-size: 14px;
            padding: 0 8px;
            background-color: #888888;
            color: #ffffff;
            white-space: nowrap;
            border: none;
          }
        `}</style>
      </>
    );
  };

  const VerifyBtnRedeem = () => {
    return count !== 0 && !otpLoading ? (
      <CountDownRedeem />
    ) : count === 0 && otpLoading ? (
      <Loading className="otpLoadingRedeem" color={"#41413A"} />
    ) : (
      <GetCodeRedeem />
    );
  };
  //*** End of RedeemPage button ***//

  return page === "home" ? <VerifyBtnHome /> : <VerifyBtnRedeem />;
}
